module.exports = __webpack_public_path__ + "static/media/managed-badge.e3fa6563.svg";